import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { aiTabs } from '../shared/aiTabs';

export default function AiTasks(props) {
    const data = {
        url: '/admin/ai/tasks',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/ai/tasks/{id}',
        userfilter:[
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Client',
                source: 'client_id',
                type: 'select',
                editable: false,
                default: '',
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'LLM',
                source: 'model_id',
                type: 'select',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Task Type',
                source: 'task_type',
                type: 'text',
                editable: false,
                default: 'voice',
                transform: (value) => {
                    const types = {
                        'voice': 'Voice',
                        'text': 'Text'
                    };
                    return types[value] || value;
                }
            },
            {
                label: 'Agent',
                source: 'agent_id',
                type: 'select',
                editable: false,
                default: '',
            },
            {
                label: 'Created At',
                source: 'created_at',
                type: 'datetime'
            },
            {
                label: 'Enabled',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                values: {
                    true: 'YES',
                    false: 'NO'
                },
                classnames: {
                    true: 'label label-info',
                    false: 'label label-danger'
                }
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }
    
    return (
        <Panel title="AI Tasks">
            <>            
                <Tabs tabs={aiTabs} />
                <DataResource
                    addButtonText="Create New AI Task"
                    addButtonType="link"
                    addButtonLink="/ai/tasks/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}